<div class="header">
  @if (config.title) {
  <div class="title-row">
    <div class="title">{{ config.title | lowerCase }}</div>
    @if (config.infoConfig) {
    <i class="pi pi-question-circle info" (click)="onInfoIconClicked()"></i>
    } @if (config.settingsPath) {
    <i class="pi pi-cog info" (click)="onSettingsGearClicked()"></i>
    }
  </div>
  }
</div>
<div class="labeled-container">
  <ng-content></ng-content>
</div>
